module.exports = __webpack_public_path__ + "media/images/map-screenshot-52e1fd4782b78c3aaeb7d28d53fe96c9.png";